'use strict';

module.exports = require('./Switch');


//////////////////
// WEBPACK FOOTER
// ./~/_rc-switch@1.5.3@rc-switch/lib/index.js
// module id = 751
// module chunks = 0 1